import React from 'react';

function EPAbout() {
  return (
    <div>EPAbout</div>
  );
}

export default EPAbout;
